import { render, staticRenderFns } from "./adjustmentRecord.vue?vue&type=template&id=4289a118&scoped=true&"
import script from "./adjustmentRecord.vue?vue&type=script&lang=js&"
export * from "./adjustmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./adjustmentRecord.vue?vue&type=style&index=0&id=4289a118&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289a118",
  null
  
)

export default component.exports